module.exports = __webpack_public_path__ + "media/images/lb/266-9dcc48e8eb12628463d82a945b4e26ec.svg";